import { Directive, HostListener, inject, Input } from '@angular/core';
import { RuntimeConfigService } from '../../core/services/runtime-config.service';
import { LayoutService } from '../services/layout.service';

@Directive({
  selector: '[spsMobileDetection]'
})
export class MobileDetectionDirective {

  @Input() mobileBreakpoint: number = inject(RuntimeConfigService).mobileBreakpoint;

  private layoutService = inject(LayoutService);

  /**
   * Listener auf window resize event
   * @param event
   */
  @HostListener('window:resize', ['$event'])
  resizeEvent(event) {
    this.layoutService.isMobile.set(window.innerWidth < this.mobileBreakpoint);
    this.layoutService.contentHeight.set(window.innerHeight);
  }


}
